"use strict";

import mainStyle from "../css/sass/main.scss";

import customSlider from "./modules/customSlide";
import shareSocialMidia from "./modules/shareSocialMidia";

customSlider();
shareSocialMidia();
